import {
  AddOn_Read_Typeahead,
  getV1CompaniesCompanyIdAddOnsTypeahead,
  GetV1CompaniesCompanyIdAddOnsTypeaheadData,
} from '@treadinc/horizon-api-spec';
import { FieldValues } from 'react-hook-form';

import { AddOnTypeahead } from '~hooks/useAddOns/models';
import { appendAddOnRateTypeToName } from '~pages/Approvals/DriverPay/helpers';

import AsyncAutocompleteField from '../v2/Autocomplete/AsyncAutocompleteField';
import { CommonAsyncAutocompleteFieldProps } from '../v2/Autocomplete/types';

type Props<T extends FieldValues> = CommonAsyncAutocompleteFieldProps<
  T,
  AddOn_Read_Typeahead,
  AddOnTypeahead,
  GetV1CompaniesCompanyIdAddOnsTypeaheadData
> & { companyId: string };

export default function AutocompleteAddOnsTypeahead<T extends FieldValues>({
  companyId,
  isDisabled,
  ...rest
}: Props<T>) {
  return (
    <AsyncAutocompleteField
      {...rest}
      isDisabled={companyId ? isDisabled : true}
      queryName="AutocompleteAddOnsTypeahead"
      fetchFn={{
        arguments: { path: { 'company-id': companyId } },
        request: getV1CompaniesCompanyIdAddOnsTypeahead,
      }}
      parseFn={(item: AddOn_Read_Typeahead) => {
        const parsed = AddOnTypeahead.parse(item);

        return {
          _entity: parsed,
          label: appendAddOnRateTypeToName(parsed.name, parsed.addOnRateType),
          value: parsed.id,
        };
      }}
    />
  );
}
